// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-data-table-header .v-data-table__checkbox.v-simple-checkbox .v-input--selection-controls__input .v-icon {\n  color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
